import { useCallback } from 'react'

import { useLocalStorage } from '@buffer-mono/popcorn'

/** Set once the reader has dismissed the explanation, so it never returns. */
const DISMISSED_KEY = 'reorder-posts-coachmark-dismissed'

type UseReorderPostsCoachmarkResult = {
  shouldShowCoachmark: boolean
  dismissCoachmark: () => void
}

/**
 * Whether the reorder control still needs explaining.
 *
 * Dismissal is remembered for good, so the explanation is a one-time thing.
 */
export const useReorderPostsCoachmark = (): UseReorderPostsCoachmarkResult => {
  const [hasBeenDismissed, setHasBeenDismissed] = useLocalStorage<boolean>(
    DISMISSED_KEY,
    false,
  )

  const dismissCoachmark = useCallback((): void => {
    setHasBeenDismissed(true)
  }, [setHasBeenDismissed])

  return { shouldShowCoachmark: !hasBeenDismissed, dismissCoachmark }
}
